export default "/logo_icon.d6fb038c-12ca70.png";